import type { MyShareItem, MySharesResponse } from '@reqshare/shared';

const API_BASE = import.meta.env.VITE_API_BASE || 'http://localhost:3000';

export async function getMyShares(token: string): Promise<MyShareItem[]> {
  const response = await fetch(`${API_BASE}/requests/mine`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    let message = response.statusText;
    try {
      const body = await response.json();
      message = body.message || message;
    } catch {
      // fall through
    }
    throw new Error(message);
  }

  const data: MySharesResponse = await response.json();
  return data.items;
}
